import { Download } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { generateICSContent } from "@core/features/calendar";
import type { Meeting } from "@core/features/meeting";

export type Props = {
  meeting: Meeting;
  onClick?: () => void;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
  onAddCalendarEvent: (
    meetingId: number,
    calendarType: "google" | "ical"
  ) => void;
};

export function AddToICalButton({
  meeting,
  onClick,
  eventTitle,
  eventDescription,
  eventUrl,
  onAddCalendarEvent,
}: Props) {
  const handleClick = () => {
    const icsContent = generateICSContent([meeting], {
      eventTitle,
      eventDescription,
      eventUrl,
    });

    // Create blob and trigger download
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "pollinator-meeting.ics";

    onAddCalendarEvent(meeting.id, "ical");

    link.click();

    URL.revokeObjectURL(url);

    onClick?.();
  };

  return (
    <Button variant="secondary" iconComponent={Download} onClick={handleClick}>
      Add to iCal
    </Button>
  );
}

export default AddToICalButton;
